import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { List, ListItem } from 'material-ui/List'
import imgFacebook from '../../assets/images/icons/facebook.svg'
import imgGoogle from '../../assets/images/icons/google.svg'
import './Login.less'

export default function Login(props) {
	const actions = [
		<FlatButton
			label="Stay anonymous"
			onTouchTap={props.hide}
		/>,
	]

	return (
		<div className="login">
			{props.user && !props.user.isAnonymous ? (
				<FlatButton label="Sign Out" onClick={props.signOut} />
			) : (
				<FlatButton label="Sign In" onClick={props.show} />
			)}
			<Dialog
				title="Login"
				actions={actions}
				modal={false}
				open={props.app.showSignIn}
				onRequestClose={props.hide}
			>
				<p>You really should login, it&#39;s what all the cool kids do.</p>
				<List>
					<ListItem
						leftIcon={<img alt="" src={imgFacebook} />}
						onClick={props.signInWithFacebook}
						primaryText="Facebook"
					/>
					<ListItem
						leftIcon={<img alt="" src={imgGoogle} />}
						onClick={props.signInWithGoogle}
						primaryText="Google"
					/>
				</List>
			</Dialog>
		</div>
	)
}

Login.propTypes = {
	app: PropTypes.shape({
		showSignIn: PropTypes.bool.isRequired,
	}).isRequired,
	hide: PropTypes.func.isRequired,
	show: PropTypes.func.isRequired,
	signInAnonymously: PropTypes.func.isRequired,
	signInWithFacebook: PropTypes.func.isRequired,
	signInWithGoogle: PropTypes.func.isRequired,
	signOut: PropTypes.func.isRequired,
	user: PropTypes.shape({
		isAnonymous: PropTypes.bool.isRequired,
	}),
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx